const currentUrl = window.location.href;
const slider = document.querySelector('.HP-Soldes-2025__links');

// Check if the element with class "HP-Soldes-2025__hp" is absent
if (!document.querySelector('.HP-Soldes-2025')) {
    const sliderLP = document.querySelector('.LP-Soldes-2025__links');

    // Add 'active-link' class to the button matching the current URL
    document.querySelectorAll('.LP-Soldes-2025__links').forEach(button => {
        const buttonUrl = button.getAttribute('href');
        if (currentUrl === buttonUrl) {
            button.classList.add("active-link");

            // Center the active button in mobile view
            setTimeout(() => {
                if (window.innerWidth < 1024) {
                    const scrollPosition = button.offsetLeft - (sliderLP.offsetWidth - button.offsetWidth) / 2;
                    sliderLP.scrollLeft = scrollPosition;
                }
            }, 50);
        }
    });

    // Highlight the "Tout voir" button if no other button is active
    const mainCTA = document.querySelector('.LP-Soldes-2025__links');
    if (mainCTA && !document.querySelector('.active-link')) {
        mainCTA.querySelector('.LP-Soldes-2025__button').classList.add('active-link');
    }
}

// Function to stop the animation
const stopAnimation = () => {
    slider.classList.add('stop-anim'); // Add a class to stop the animation
    document.cookie = "stop-anim=true; max-age=300"; // Cookie expires in 5 minutes
};

// Check if the "stop-anim" cookie exists
const isAnimationStopped = document.cookie.split('; ').some(cookie => cookie.startsWith('stop-anim='));

// If the animation has not been stopped, add event listeners for scroll and touchstart
if (!isAnimationStopped) {
    const interactionHandler = () => {
        stopAnimation(); // Stop the animation
        window.removeEventListener('scroll', interactionHandler); // Remove scroll listener
        window.removeEventListener('touchstart', interactionHandler); // Remove touchstart listener
    };

    // Add event listeners for scroll and touchstart
    window.addEventListener('scroll', interactionHandler, { once: true });
    window.addEventListener('touchstart', interactionHandler, { once: true });
}

// Read the cookie to disable animation if previously set
if (document.cookie.includes("stop-anim=true")) {
    slider.classList.add('stop-anim');
}